enum AppEnvironment {
    DEMO = 'DEMO',
    DEMO2 = 'DEMO2',
    DEMO3 = 'DEMO3',
    DEMO4 = 'DEMO4',
    DEMO5 = 'DEMO5',
    DEMO6 = 'DEMO6',
    DEVOPS = 'DEVOPS',
    MOCK = 'MOCK',
    PROD = 'PROD',
    CROSS_BROWSER = 'CROSS_BROWSER',
    DEV = 'DEV'
    }

export default AppEnvironment;